import React, {useState, useRef} from 'react'
import {useSelector} from 'react-redux';
import BudgetReappropriateList from '../../components/BudgetReappropriate/BudgetReappropriateList';
import CreateButton from '../../components/Tools/CreateButton';
import SubHeader from '../../components/Subheader/Subheader';


export default function BudgetReappropriateListPage() {
    const {authData, financialYears} = useSelector((state) => state.authData);
    const fyList = financialYears.payload.fy_list;
    const fyIdRef = useRef(localStorage.getItem('globalDateId'));
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [dateColumn, setDateColumn] = useState('approval_date');
    const [searchStr, setToSearchStr] = useState('');

    const handlePageTrigger = () => {
        fyIdRef.current = localStorage.getItem('globalDateId');
    }
    return (
        <div>
            <SubHeader fy_list={fyList} handlePageTrigger={handlePageTrigger}/>
            <div className='scheme p-2'>
                <BudgetReappropriateList fromDate={fromDate} toDate={toDate} dateColumn={dateColumn} searchStr={searchStr}/>
            </div>
            { authData.user.user_type === 'l1' && <CreateButton title={"Add Budget Revision"} url={"/add-budget-reappropriate"}/> }
        </div>
    )
}